import AxiosClient from './api'
import END_POINT from './constants'

export function createPortFolio(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.PORTFOLIO.PORTFOLIO}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getPortFolioByUserId(userId) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.PORTFOLIO.GET_PORTFOLIO_BY_USERID}/${userId}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getPortFolioWithId({ idUser, id }) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.PORTFOLIO.PORTFOLIO_INFO_USER}/${idUser}/${id}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function deletePortFolioWithId({ id }) {
  return new Promise((resolve, reject) => {
    AxiosClient.delete(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function updateTimeIPOPortfolio({ id, time }) {
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}/timeipo/${time}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getAssetGoalsWithRequest({ id }) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}/asset-goals`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getGrowthSchedulesWithRequest({ id }) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}/growth-schedules`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function editAnnualAssetGoalsWithRequest({ id, ...payload }) {
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}/asset-goals`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function editGrowthSchedulesWithRequest({ id, ...payload }) {
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}/growth-schedules`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getAllRolePermissionRequest({ id }) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.MEMBER_ROLES}/${id}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getAllMemberInPortFolioRequest({ id }) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.PORTFOLIO.ALL_MEMBER_PORTFOLIO}/${id}/members?sortBy=role_id&sortType=ASC`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function inviteMemberPortFolio({ id, ...payload }) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.PORTFOLIO.PORTFOLIO_MEMBER_INVITE}/${id}/invite-member`, { ...payload.values })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function acceptInvitationMemberOfPortfolio(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.PORTFOLIO.ACCEPT_INVITE_MEMBER}`, { ...payload })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function verifyInvitationMemberOfPortfolio({ code }) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.PORTFOLIO.VERIFY_INVITE_MEMBER}/${code}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function deletePortfolioMemberRequest({ id, userId, ...payload }) {
  return new Promise((resolve, reject) => {
    AxiosClient.delete(`${END_POINT.PORTFOLIO.DELETE_PORTFOLIO_MEMBER}/${id}/members/${userId}`, { ...payload })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function updatePortfolioName({ id, name }) {
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}/name/${name.name}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function updateCurrency({ id, currency }) {
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.PORTFOLIO.UPDATE_CURRENCY}/${id}/currency/${currency}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}
